export const Types = {
  SET_IS_CROSS_SELL_CHECKED: 'crossSell/SET_IS_CROSS_SELL_ENABLE',
};

export interface ICrossSellReduxState {
  isChecked: boolean;
}

const initialState: ICrossSellReduxState = {
  isChecked: true,
};

export default function reducer(state = initialState, action: any = {}): ICrossSellReduxState {
  switch (action.type) {
    case Types.SET_IS_CROSS_SELL_CHECKED:
      return { ...state, isChecked: action.payload };
    default:
      return state;
  }
}

export const setIsCrossSellChecked = (isChecked: boolean) => ({
  type: Types.SET_IS_CROSS_SELL_CHECKED,
  payload: isChecked,
});

export const crossSellActions = {
  setIsCrossSellChecked,
};
